import {
  Alert,
  Button,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
} from '@apollo/orbit';
import React from 'react';

import { org } from 'src/app/account/routes';

export const DeleteUserBlockerModal = ({
  isOpen,
  onRequestClose,
  orgsPreventingUserFromDeletingSelf,
}: {
  isOpen: boolean;
  onRequestClose: () => void;
  orgsPreventingUserFromDeletingSelf: { name: string; id: string }[];
}) => {
  return (
    <Modal isOpen={isOpen} size="xl" onClose={onRequestClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>We can't delete your user account yet</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Alert status="warning">
            You're the main contact of a paid organization.
          </Alert>
          <p>
            Before we can delete your account, you must first leave or delete
            organizations that you are a member of that are currently on a paid
            plan:
          </p>
          <ul className="list-inside list-disc">
            {orgsPreventingUserFromDeletingSelf.map(({ name, id }) => (
              <li key={id}>
                <Link to={org.location({ orgId: id })}>{name}</Link>
              </li>
            ))}
          </ul>
          <p>Once that’s completed, you’ll be able to delete your account.</p>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={onRequestClose}>
            Got it
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
